
<div>
    <!-- No Results Message -->
    <div v-if="isLoading" class="text-center text-gray-500">
        Searching for Classes...
    </div>
    <div v-else-if="searchResults.length === 0" class="text-center text-gray-500">
        No classes were found that matched your criteria. Please try expanding your search.
    </div>

    <!-- Card Layout -->
    <div v-else class="grid grid-cols-1 gap-6 card-container md:grid-cols-2 lg:grid-cols-3">
        <div v-for="(row, index) in filteredResults" :key="index" class="card">
            <div class="card-content">
                <div class="top-card">
                    <h3 class="card-title">{{ row.certification }}</h3>
                    <template v-if="row.certificationAbbreviation.includes(',')">
                        <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                            <span v-for="(cert, index) in row.certificationAbbreviation.split(',')" :key="index">
                                <img 
                                    class="h-auto w-14 badge-img" 
                                    :alt="cert.trim()" 
                                    :src="['IMC-CC', 'IMC-EI', 'IMC-LS', 'IMC-CM'].includes(cert.trim()) 
                                        ? `/media/badges/micro-credentials/${cert.trim()}.png` 
                                        : `/media/badges/${cert.trim()}.svg`">
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <img 
                            class="h-auto w-14 badge-img" 
                            :alt="row.certification" 
                            :src="row.certificationAbbreviation.startsWith('IMC-') 
                                ? `/media/badges/micro-credentials/${row.certificationAbbreviation}.png` 
                                : `/media/badges/${row.certificationAbbreviation}.svg`">
                    </template>
                </div>
                <div class="delivery-method" :class="getDeliveryMethodClass(row.location)">
                    {{
                        getDeliveryMethodClass(row.location) === 'delivery-in-person'
                            ? 'In-Person'
                            : getDeliveryMethodClass(row.location) === 'delivery-self-paced'
                                ? 'On Demand'
                                : row.location
                    }}
                </div>

                <ul class="card-details">
                    <li>
                        <img src="/media/find-a-class/find-a-class-detail-page-instructors.svg" alt="provider icon"
                            class="icon" />
                        {{ row.provider }}
                    </li>
                    <li v-if="row.location !== 'Self-Paced'">
                        <img src="/media/find-a-class/start-date.svg" alt="date icon" class="icon" />
                        {{ row.time.formattedDate }}
                    </li>
                    <li v-if="row.location !== 'Self-Paced'">
                        <img src="/media/find-a-class/class-detail-time.svg" alt="time icon" class="icon" />
                        {{ row.time.timeZone }}
                    </li>
                    <li v-if="row.location == 'Self-Paced'">
                        <img src="/media/find-a-class/class-detail-time.svg" alt="time icon" class="icon" />
                        Self-Paced
                    </li>
                    <li v-if="row.location !== 'Remote' && row.location !== 'Self-Paced'">
                        <img src="/media/find-a-class/find-a-class-detail-page-location.svg" alt="location icon"
                            class="icon" />
                        {{ row.location }}
                    </li>
                    <li>
                        <img src="/media/find-a-class/language.svg" alt="language icon" class="icon" />
                        {{ row.language }}
                    </li>
                    <li v-if="row.guaranteedToRun">
                        <img src="/media/find-a-class/guaranteed-to-run-results.svg" alt="guaranteed to run icon"
                            class="icon" />
                        Guaranteed To Run
                    </li>
                </ul>
            </div>

            <div class="card-actions">
                <a class="learn-more" @click="onRowClick(row)">Learn More</a>
                <a :href="row.registrationUrl" target="_blank" class="register-button register-class">Register</a>
            </div>

        </div>
    </div>

    <!-- Infinite Scroll Trigger -->
    <div ref="scrollTrigger" class="scroll-trigger" v-if="hasMoreData && !isLoadingMore"></div>

    <!-- Loading Spinner -->
    <div v-if="isLoadingMore" class="spinner">
        <div class="spinner-circle"></div>
    </div>

    <!-- End of Search Message -->
    <div v-if="!hasMoreData && searchResults.length > 0 && !isLoadingMore" class="end-of-search">
        End of Search
    </div>
</div>
